import React from "react";

// reactstrap components
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  NavItem,
  NavLink,
  Nav,
  TabContent,
  TabPane,
  Container,
  Row,
  Col,
} from "reactstrap";

// core components
import IndexNavbar from "components/Navbars/IndexNavbar.js";
import MainFooter from "components/Footers/MainFooter.js";

function EducationalPrograms() {
  const [corporateTab, setCorporateTab] = React.useState("1");
  const [itTab, setItTab] = React.useState("1");
  const [childTab, setChildTab] = React.useState("1");

  const toggleCorporateTab = (tab) => {
    if (corporateTab !== tab) setCorporateTab(tab);
  };

  const toggleItTab = (tab) => {
    if (itTab !== tab) setItTab(tab);
  };

  const toggleChildTab = (tab) => {
    if (childTab !== tab) setChildTab(tab);
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    document.body.classList.add("landing-page");
    return function cleanup() {
      document.body.classList.remove("landing-page");
    };
  });

  return (
    <>
      <IndexNavbar />
      <div className="page-header section-dark" data-parallax={true}>
        <div
          className="filter"
          style={{
            background: "linear-gradient(0deg, rgba(0,0,0,0.2), rgba(255,255,255,0.2))",
          }}
        />
        <Container>
          <div className="motto text-center">
            <h1 className="presentation-title">Educational Programs & Training</h1>
            <h3 className="presentation-subtitle text-center">
              Comprehensive educational solutions for all ages and professional levels
            </h3>
          </div>
        </Container>
      </div>

      <div className="main">
        <div className="section section-light" id="programs">
          <Container>
            <Row>
              <Col className="ml-auto mr-auto text-center">
                <h2 className="title">Choose Your Educational Path</h2>
                <h5 className="description">
                  From corporate training and IT skills to child education programs, 
                  we offer comprehensive educational solutions tailored to your needs.
                </h5>
              </Col>
            </Row>
            <Row className="text-center mt-4">
              <Col md="12">
                <Button 
                  className="btn-round mr-2 mb-2"
                  color="primary"
                  onClick={() => scrollToSection('corporate-training')}
                >
                  <i className="fa fa-building"></i> Corporate Training
                </Button>
                <Button 
                  className="btn-round mr-2 mb-2"
                  color="primary"
                  onClick={() => scrollToSection('it-training')}
                >
                  <i className="fa fa-code"></i> IT Training
                </Button>
                <Button 
                  className="btn-round mr-2 mb-2"
                  color="primary"
                  onClick={() => scrollToSection('child-education')}
                >
                  <i className="fa fa-child"></i> Child Education
                </Button>
              </Col>
            </Row>
          </Container>
        </div>

        {/* Corporate Training Section */}
        <div className="section" id="corporate-training">
          <Container>
            <Row>
              <Col className="ml-auto mr-auto text-center">
                <h2 className="title text-center">Corporate Training & Organizational Change Management</h2>
                <h5 className="description text-center">
                  Drive successful organizational transformation through comprehensive leadership development and IT-business alignment programs. 
                  We help organizations build capabilities to navigate change while creating alignment between technical teams and business objectives.
                </h5>
              </Col>
            </Row>
            
            <div className="nav-tabs-navigation text-center">
              <div className="nav-tabs-wrapper">
                <Nav role="tablist" tabs className="justify-content-center">
                  <NavItem>
                    <NavLink
                      className={corporateTab === "1" ? "active" : ""}
                      onClick={() => toggleCorporateTab("1")}
                    >
                      Leadership & Change Management
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={corporateTab === "2" ? "active" : ""}
                      onClick={() => toggleCorporateTab("2")}
                    >
                      Custom Programs
                    </NavLink>
                  </NavItem>
                </Nav>
              </div>
            </div>

            <TabContent className="text-center" activeTab={corporateTab}>
              <TabPane tabId="1">
                <Row>
                  <Col md="4">
                    <Card>
                      <CardBody>
                        <CardTitle tag="h4">Technical Leadership Development</CardTitle>
                        <p>
                          Develop technical leaders who can effectively communicate with both technical teams and business stakeholders.
                          Learn to translate complex technical concepts into business value.
                        </p>
                        <ul className="text-left">
                          <li>Strategic thinking for technical leaders</li>
                          <li>Communication skills for technical professionals</li>
                          <li>Project management in technical environments</li>
                          <li>Building cross-functional teams</li>
                        </ul>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col md="4">
                    <Card>
                      <CardBody>
                        <CardTitle tag="h4">IT-Business Alignment</CardTitle>
                        <p>
                          Bridge the communication gap between business and IT teams. Help both sides understand each other's objectives and work collaboratively.
                        </p>
                        <ul className="text-left">
                          <li>Translating technical work to business value</li>
                          <li>Technology fundamentals for business teams</li>
                          <li>Requirements gathering and stakeholder management</li>
                          <li>Agile business collaboration frameworks</li>
                        </ul>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col md="4">
                    <Card>
                      <CardBody>
                        <CardTitle tag="h4">Executive Technology Training</CardTitle>
                        <p>
                          Help executives understand technology trends and their business implications. 
                          Make informed decisions about technology investments and digital transformation.
                        </p>
                        <ul className="text-left">
                          <li>Digital transformation strategies</li>
                          <li>Technology risk assessment</li>
                          <li>ROI analysis for technology investments</li>
                          <li>Emerging technology trends</li>
                        </ul>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </TabPane>
              
              <TabPane tabId="2">
                <Row>
                  <Col md="6">
                    <Card>
                      <CardBody>
                        <CardTitle tag="h4">Organizational Assessment & Strategy</CardTitle>
                        <p>
                          We begin with a comprehensive assessment of your organization's current change readiness and capabilities.
                          Design strategic change management approaches that align with your business transformation goals.
                        </p>
                        <ul className="text-left">
                          <li>Change readiness and capability gap analysis</li>
                          <li>Strategic change management planning</li>
                          <li>Stakeholder engagement and communication strategies</li>
                          <li>Cultural transformation roadmaps</li>
                        </ul>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col md="6">
                    <Card>
                      <CardBody>
                        <CardTitle tag="h4">Implementation & Sustainability</CardTitle>
                        <p>
                          Execute comprehensive change management initiatives with ongoing support to ensure sustainable transformation.
                          Focus on building internal capabilities and measuring organizational impact.
                        </p>
                        <ul className="text-left">
                          <li>Executive coaching and leadership development</li>
                          <li>Cross-functional team facilitation</li>
                          <li>Change impact measurement and analytics</li>
                          <li>Sustainable transformation practices</li>
                        </ul>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </TabPane>
            </TabContent>
                
            <Row className="text-center" style={{ marginTop: "2rem" }}>
              <Col md="12">
                <Button
                  className="btn-round"
                  color="success"
                  size="lg"
                  href="https://book.ms/b/ClassInquiries@robotyze.org"
                  target="_blank"
                >
                  Schedule a Corporate Training Consultation
                </Button>
              </Col>
            </Row>
          </Container>
        </div>

        {/* IT Training Section */}
        <div className="section section-light" id="it-training">
          <Container>
            <Row>
              <Col className="ml-auto mr-auto text-center">
                <h2 className="title text-center">IT Training for Developers & Tech Professionals</h2>
                <h5 className="description text-center">
                  Master the essential skills needed for modern software development and IT operations. 
                  From cloud platforms to development workflows, we provide comprehensive training for technical professionals.
                </h5>
              </Col>
            </Row>

            <div className="nav-tabs-navigation text-center">
              <div className="nav-tabs-wrapper">
                <Nav role="tablist" tabs className="justify-content-center">
                  <NavItem>
                    <NavLink
                      className={itTab === "1" ? "active" : ""}
                      onClick={() => toggleItTab("1")}
                    >
                      Cloud & AWS
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={itTab === "2" ? "active" : ""}
                      onClick={() => toggleItTab("2")}
                    >
                      Development Workflow
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={itTab === "3" ? "active" : ""}
                      onClick={() => toggleItTab("3")}
                    >
                      Architecture & Design
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={itTab === "4" ? "active" : ""}
                      onClick={() => toggleItTab("4")}
                    >
                      Programming Skills
                    </NavLink>
                  </NavItem>
                </Nav>
              </div>
            </div>

            <TabContent className="text-center" activeTab={itTab}>
              <TabPane tabId="1">
                <Row>
                  <Col md="6">
                    <Card>
                      <CardBody>
                        <CardTitle tag="h4">
                          <i className="fa fa-cloud"></i> AWS Fundamentals
                        </CardTitle>
                        <p>
                          Learn the core AWS services and best practices for cloud computing.
                        </p>
                        <ul className="text-left">
                          <li>EC2, S3, RDS, Lambda basics</li>
                          <li>IAM and security fundamentals</li>
                          <li>VPC networking</li>
                          <li>Cost optimization strategies</li>
                        </ul>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col md="6">
                    <Card>
                      <CardBody>
                        <CardTitle tag="h4">
                          <i className="fa fa-cogs"></i> DevOps & Infrastructure
                        </CardTitle>
                        <p>
                          Infrastructure as Code, containerization, and deployment strategies.
                        </p>
                        <ul className="text-left">
                          <li>Docker and containerization</li>
                          <li>Kubernetes fundamentals</li>
                          <li>Terraform for infrastructure</li>
                          <li>CloudFormation templates</li>
                        </ul>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </TabPane>
                    
              <TabPane tabId="2">
                <Row>
                  <Col md="6">
                    <Card>
                      <CardBody>
                        <CardTitle tag="h4">
                          <i className="fa fa-github"></i> Git & GitHub
                        </CardTitle>
                        <p>
                          Master version control and collaborative development workflows.
                        </p>
                        <ul className="text-left">
                          <li>Git fundamentals and branching</li>
                          <li>GitHub workflows and pull requests</li>
                          <li>Code review best practices</li>
                          <li>GitHub Actions for automation</li>
                        </ul>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col md="6">
                    <Card>
                      <CardBody>
                        <CardTitle tag="h4">
                          <i className="fa fa-rocket"></i> CI/CD Pipelines
                        </CardTitle>
                        <p>
                          Implement continuous integration and deployment pipelines.
                        </p>
                        <ul className="text-left">
                          <li>GitHub Actions workflows</li>
                          <li>Jenkins pipeline setup</li>
                          <li>Automated testing integration</li>
                          <li>Deployment strategies</li>
                        </ul>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </TabPane>
                    
              <TabPane tabId="3">
                <Row>
                  <Col md="6">
                    <Card>
                      <CardBody>
                        <CardTitle tag="h4">
                          <i className="fa fa-sitemap"></i> System Architecture
                        </CardTitle>
                        <p>
                          Design scalable and maintainable system architectures.
                        </p>
                        <ul className="text-left">
                          <li>Microservices architecture</li>
                          <li>API design and REST principles</li>
                          <li>Database design and scaling</li>
                          <li>Performance optimization</li>
                        </ul>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col md="6">
                    <Card>
                      <CardBody>
                        <CardTitle tag="h4">
                          <i className="fa fa-shield"></i> Security Best Practices
                        </CardTitle>
                        <p>
                          Implement security measures throughout the development lifecycle.
                        </p>
                        <ul className="text-left">
                          <li>Secure coding practices</li>
                          <li>Authentication and authorization</li>
                          <li>OWASP Top 10 vulnerabilities</li>
                          <li>Security testing and monitoring</li>
                        </ul>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </TabPane>
                    
              <TabPane tabId="4">
                <Row>
                  <Col md="4">
                    <Card>
                      <CardBody>
                        <CardTitle tag="h4">
                          <i className="fa fa-code"></i> Programming Languages
                        </CardTitle>
                        <ul className="text-left">
                          <li>Python for automation</li>
                          <li>JavaScript/Node.js</li>
                          <li>Java for enterprise</li>
                          <li>Go for systems programming</li>
                        </ul>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col md="4">
                    <Card>
                      <CardBody>
                        <CardTitle tag="h4">
                          <i className="fa fa-database"></i> Database Skills
                        </CardTitle>
                        <ul className="text-left">
                          <li>SQL fundamentals</li>
                          <li>NoSQL databases</li>
                          <li>Database optimization</li>
                          <li>Data modeling</li>
                        </ul>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col md="4">
                    <Card>
                      <CardBody>
                        <CardTitle tag="h4">
                          <i className="fa fa-bug"></i> Testing & Debugging
                        </CardTitle>
                        <ul className="text-left">
                          <li>Unit testing frameworks</li>
                          <li>Integration testing</li>
                          <li>Debugging techniques</li>
                          <li>Performance profiling</li>
                        </ul>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </TabPane>
            </TabContent>
                
            <Row className="text-center" style={{ marginTop: "2rem" }}>
              <Col md="12">
                <Button
                  className="btn-round"
                  color="success"
                  size="lg"
                  href="https://book.ms/b/ClassInquiries@robotyze.org"
                  target="_blank"
                >
                  Enroll in IT Training Programs
                </Button>
              </Col>
            </Row>
          </Container>
        </div>

        {/* Child Education Section */}
        <div className="section" id="child-education">
          <Container>
            <Row>
              <Col className="ml-auto mr-auto text-center">
                <h2 className="title text-center">Child Education Programs</h2>
                <h5 className="description text-center">
                  Inspiring the next generation through hands-on learning in science, coding, engineering, and archery. 
                  Our programs combine traditional educational concepts with engaging, practical activities.
                </h5>
              </Col>
            </Row>

            <div className="nav-tabs-navigation text-center">
              <div className="nav-tabs-wrapper">
                <Nav role="tablist" tabs className="justify-content-center">
                  <NavItem>
                    <NavLink
                      className={childTab === "1" ? "active" : ""}
                      onClick={() => toggleChildTab("1")}
                    >
                      Science & Engineering
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={childTab === "2" ? "active" : ""}
                      onClick={() => toggleChildTab("2")}
                    >
                      Coding & Technology
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={childTab === "3" ? "active" : ""}
                      onClick={() => toggleChildTab("3")}
                    >
                      Archery
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={childTab === "4" ? "active" : ""}
                      onClick={() => toggleChildTab("4")}
                    >
                      Project-Based Learning
                    </NavLink>
                  </NavItem>
                </Nav>
              </div>
            </div>

            <TabContent className="text-center" activeTab={childTab}>
              <TabPane tabId="1">
                <Row>
                  <Col md="6">
                    <Card>
                      <CardBody>
                        <CardTitle tag="h4">
                          <i className="fa fa-flask"></i> Science Exploration
                        </CardTitle>
                        <p>
                          Discover the wonders of science through hands-on experiments and investigations.
                        </p>
                        <ul className="text-left">
                          <li>Physics experiments with everyday materials</li>
                          <li>Chemistry through safe, fun reactions</li>
                          <li>Biology and life science observations</li>
                          <li>Earth science and environmental studies</li>
                        </ul>
                        <img
                          alt="Science Activities"
                          className="img-rounded img-responsive"
                          src={require("assets/img/Activities/Heat Airflow.png")}
                          style={{ width: "80%", marginTop: "10px" }}
                        />
                      </CardBody>
                    </Card>
                  </Col>
                  <Col md="6">
                    <Card>
                      <CardBody>
                        <CardTitle tag="h4">
                          <i className="fa fa-cog"></i> Engineering Design
                        </CardTitle>
                        <p>
                          Learn engineering principles through building and problem-solving challenges.
                        </p>
                        <ul className="text-left">
                          <li>Bridge building and structural engineering</li>
                          <li>Simple machines and mechanical systems</li>
                          <li>Robotics and automation basics</li>
                          <li>Design thinking and prototyping</li>
                        </ul>
                        <img
                          alt="Engineering Projects"
                          className="img-rounded img-responsive"
                          src={require("assets/img/Activities/Smores Bridge.jpeg")}
                          style={{ width: "80%", marginTop: "10px" }}
                        />
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </TabPane>
                    
              <TabPane tabId="2">
                <Row>
                  <Col md="6">
                    <Card>
                      <CardBody>
                        <CardTitle tag="h4">
                          <i className="fa fa-code"></i> Programming Basics
                        </CardTitle>
                        <p>
                          Introduction to coding concepts through visual and interactive platforms.
                        </p>
                        <ul className="text-left">
                          <li>Scratch programming for beginners</li>
                          <li>Python basics for young coders</li>
                          <li>HTML/CSS for web creation</li>
                          <li>Logic and problem-solving skills</li>
                        </ul>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col md="6">
                    <Card>
                      <CardBody>
                        <CardTitle tag="h4">
                          <i className="fa fa-microchip"></i> Technology & Electronics
                        </CardTitle>
                        <p>
                          Explore electronics and technology through hands-on projects.
                        </p>
                        <ul className="text-left">
                          <li>LED circuits and basic electronics</li>
                          <li>Arduino microcontroller projects</li>
                          <li>Sensors and automation</li>
                          <li>3D printing and digital fabrication</li>
                        </ul>
                        <img
                          alt="LED Projects"
                          className="img-rounded img-responsive"
                          src={require("assets/img/Activities/LED array.png")}
                          style={{ width: "80%", marginTop: "10px" }}
                        />
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </TabPane>
                    
              <TabPane tabId="3">
                <Row>
                  <Col md="6">
                    <Card>
                      <CardBody>
                        <CardTitle tag="h4">
                          <i className="fa fa-bullseye"></i> Archery Form & Coaching
                        </CardTitle>
                        <p>
                          Develop proper archery technique and mental discipline through expert coaching.
                        </p>
                        <ul className="text-left">
                          <li>Proper stance and posture fundamentals</li>
                          <li>Bow handling and safety protocols</li>
                          <li>Aiming and shooting technique</li>
                          <li>Breathing and focus methods</li>
                          <li>Progressive skill development</li>
                          <li>Mental conditioning and concentration</li>
                        </ul>
                        <p>
                          <strong>Age-appropriate coaching:</strong> From basic safety and fun activities for younger children 
                          to advanced technique refinement for competitive teens.
                        </p>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col md="6">
                    <Card>
                      <CardBody>
                        <CardTitle tag="h4">
                          <i className="fa fa-crosshairs"></i> Equipment Selection & Configuration
                        </CardTitle>
                        <p>
                          Learn about archery equipment and how proper setup affects performance.
                        </p>
                        <ul className="text-left">
                          <li>Bow selection based on age and skill level</li>
                          <li>Arrow spine and weight matching</li>
                          <li>Sight adjustment and tuning</li>
                          <li>Rest and nocking point setup</li>
                          <li>String maintenance and care</li>
                          <li>Equipment safety inspections</li>
                        </ul>
                        <p>
                          <strong>Hands-on learning:</strong> Students gain practical experience with equipment setup, 
                          understanding how each component affects accuracy and consistency.
                        </p>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </TabPane>
                    
              <TabPane tabId="4">
                <Row>
                  <Col md="12">
                    <Card>
                      <CardBody>
                        <CardTitle tag="h4">
                          <i className="fa fa-lightbulb-o"></i> Integrated Project Learning
                        </CardTitle>
                        <p>
                          Our signature approach combines multiple disciplines into engaging, real-world projects.
                        </p>
                        <Row>
                          <Col md="4">
                            <h5>Sample Project: Weather Station</h5>
                            <ul className="text-left">
                              <li><strong>Science:</strong> Meteorology and climate</li>
                              <li><strong>Engineering:</strong> Sensor design and housing</li>
                              <li><strong>Coding:</strong> Data collection and analysis</li>
                              <li><strong>Focus:</strong> Long-term observation skills</li>
                            </ul>
                          </Col>
                          <Col md="4">
                            <h5>Sample Project: Archery Trainer</h5>
                            <ul className="text-left">
                              <li><strong>Science:</strong> Physics of projectile motion</li>
                              <li><strong>Engineering:</strong> Target design and construction</li>
                              <li><strong>Coding:</strong> Score tracking application</li>
                              <li><strong>Archery:</strong> Practical skill application</li>
                            </ul>
                          </Col>
                          <Col md="4">
                            <h5>Sample Project: Robot Pet</h5>
                            <ul className="text-left">
                              <li><strong>Science:</strong> Animal behavior studies</li>
                              <li><strong>Engineering:</strong> Mechanical movement design</li>
                              <li><strong>Coding:</strong> AI behavior programming</li>
                              <li><strong>Focus:</strong> Patience in troubleshooting</li>
                            </ul>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </TabPane>
            </TabContent>
                
            <Row className="text-center" style={{ marginTop: "2rem" }}>
              <Col md="12">
                <Button
                  className="btn-round"
                  color="success"
                  size="lg"
                  href="https://book.ms/b/ClassInquiries@robotyze.org"
                  target="_blank"
                >
                  Enroll Your Child in Our Programs
                </Button>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
      <MainFooter />
    </>
  );
}

export default EducationalPrograms;